/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewchartsubtitle2Inputs */

const en_overviewchartsubtitle2 = /** @type {(inputs: Overviewchartsubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How often your places and events were shown and opened on Pulsify`)
};

const de_overviewchartsubtitle2 = /** @type {(inputs: Overviewchartsubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie oft deine Orte und Events auf Pulsify gezeigt und geöffnet wurden`)
};

/**
* | output |
* | --- |
* | "How often your places and events were shown and opened on Pulsify" |
*
* @param {Overviewchartsubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewchartsubtitle2 = /** @type {((inputs?: Overviewchartsubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewchartsubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewchartsubtitle2(inputs)
	return de_overviewchartsubtitle2(inputs)
});
export { overviewchartsubtitle2 as "overviewChartSubtitle" }